<app-header *ngIf="session_data.role == 1"></app-header>
<app-projects-header *ngIf="session_data.role == 2"></app-projects-header>
<div class="content_wrapper">
    <div class="add_user">
        <div class="col-md-8">
            <div class="add_form_sec">
                <h4>Change Password</h4>
                <form [formGroup]="form" (ngSubmit)="change_password()">
                    <div class="form-group">
                        <label for="username">Current Password</label>
                        <input type="password" name="old_password" class="form-control" formControlName="old_password">
                        <span class="error_message" *ngIf="err.old_password">{{err.old_password}}</span>
                    </div>
                    <div class="form-group">
                        <label for="username">New Password</label>
                        <input type="password" name="new_password" class="form-control" formControlName="new_password">
                        <span class="error_message" *ngIf="err.new_password">{{err.new_password}}</span>
                    </div>
                    <div class="form-group">
                        <label for="username">Confirm Password</label>
                        <input type="password" name="confirm_password" class="form-control" formControlName="confirm_password">
                        <span class="error_message" *ngIf="err.confirm_password">{{err.confirm_password}}</span>
                    </div>
                    <div class="form-group btn-up">
                        <button class="panel_save_btn">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgb(199, 28, 109)" type="square-loader" [fullScreen]="true"></ngx-spinner>
